<template>
    <transition name="slide-fade">
        <div class="error-message" v-if="msg">
            <small class="form-text">
                {{msg}}
            </small>
        </div>
    </transition>
</template>

<script>
  export default {
    name: 'errorMessage',
    props: {
      msg: String
    }
  }
</script>

<style scoped lang="scss">
    @import "../assets/css/colors";

    .error-message {
        color: $danger;
    }
</style>
